import React, { useEffect, useRef } from "react";
import { FileTextOutlined, VideoCameraOutlined } from "@ant-design/icons";
import AlertComponent from "../../components/alerts/AlertComponent.js";
import { Tooltip } from "antd";

const AttachmentOptions = ({
  isVisible,
  setShowAttachmentOptions,
  user,
  setLoading,
  setStatusMessage,
}) => {
  const optionsRef = useRef(null); // Ref to the attachment options container

  useEffect(() => {
    // Function to detect click outside
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        // Close attachment options when clicking outside
        if (isVisible) {
          console.log("Click outside detected, closing options");
          document.getElementById("attachment-button").click(); // Trigger the button click to toggle
        }
      }
    };

    // Add event listener for clicks
    // document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on unmount
    return () => {
      //   document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible]); // Only trigger when isVisible changes

  if (!isVisible) return null;

  const handleFileSelect = async (event, fileType) => {
    const file = event.target.files[0];
    if (!file) return;

    console.log(`File selected: ${file.name}`);
    console.log(`fileType selected: ${fileType}`);

    // Create a FormData object to send the file to the server
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileType", fileType);

    formData.append("user_id", user);
    let endpoint = "";
    setLoading(true);
    if (fileType === "document") {
      endpoint = "process-file";
      setStatusMessage("Uploading file......");
    } else if (fileType === "video") {
      // Check that this matches "video"
      endpoint = "upload-video";
      setStatusMessage("Uploading video......");
    }

    try {
      const response = await fetch(
        `https://nigeria.1dataconnect.com/webBotService/${endpoint}`,
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await response.json();
      if (result.success) {
        console.log("File uploaded successfully:", result);
        AlertComponent({
          type: "success",
          title: "Success",
          text: "File uploaded successfully!",
          icon: "success",
        });
      } else {
        AlertComponent({
          type: "error",
          title: "Error",
          text: "Error uploading file: " + result.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error uploading file:", error);

      AlertComponent({
        type: "error",
        title: "Error",
        text: "Error uploading file: " + error.message,
        icon: "error",
      });
    } finally {
      setShowAttachmentOptions(false);
      setLoading(false);
      setStatusMessage(null);
    }
  };

  return (
    <div
      id="attachment-options"
      className="attachment-options"
      ref={optionsRef}
    >
      {/* Document Option */}
      <div id="upload-document" className="option" data-type="document">
        <Tooltip title="Only PDF files are allowed">
          <label htmlFor="document-upload" className="upload-label">
            <FileTextOutlined
              style={{ marginRight: "8px", color: "#1890ff" }}
            />
            Document
          </label>
        </Tooltip>
        <input
          type="file"
          id="document-upload"
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={(e) => handleFileSelect(e, "document")}
        />
      </div>

      <div className="option" data-type="videos" id="upload-video">
        <label htmlFor="video-upload" className="upload-label">
          <VideoCameraOutlined
            style={{ marginRight: "8px", color: "#f5222d" }}
          />
          Videos
        </label>
        <input
          type="file"
          id="video-upload"
          accept="video/*"
          style={{ display: "none" }}
          onChange={(e) => handleFileSelect(e, "video")}
        />
      </div>

      {/* Medical Records Option */}
      {/* <div className="option" data-type="medical-records">
        <label htmlFor="medical-records-upload">
          <span className="material-icons">medical_services</span> Medical
          Records
        </label>
        <input
          type="file"
          id="medical-records-upload"
          accept="application/pdf, .doc, .docx"
          style={{ display: "none" }}
          onChange={(e) => handleFileSelect(e, "medical")}
        />
      </div> */}
    </div>
  );
};

export default AttachmentOptions;
